module.exports = __webpack_public_path__ + "static/media/stijn-bessem-testimonials-mick@2x.f64937a7.jpg";